var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6167 7.10833H16.3834M7.2917 15.4167V9.58333M10 15.4167V9.58333M12.7084 15.4167V9.58333M6.25003 3H13.75C14.6705 3 15.4167 3.74619 15.4167 4.66667V16.3333C15.4167 17.2538 14.6705 18 13.75 18H6.25003C5.32956 18 4.58337 17.2538 4.58337 16.3333V4.66667C4.58337 3.74619 5.32956 3 6.25003 3Z",
    stroke: "#DF1C41",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.36998ad5ab8e215e3ae21e61b05c511f.svg";
export { ForwardRef as ReactComponent };